module.exports = __webpack_public_path__ + "img/s1.4c267f91.png";